import { render } from "./ButtonPartners.vue?vue&type=template&id=5fd2e5dc"
import script from "./ButtonPartners.vue?vue&type=script&lang=js"
export * from "./ButtonPartners.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__